import React, { useState } from "react";
import { GrFormClose } from "react-icons/gr";
import { ClockModalIcon } from "assets/iconsSVG/clockModalIcon";
import { usePostAtualizarLeadTarefaConcluida } from "../../services/api/Common_TarefasLeads/atualizar-lead-tarefa-concluida";
import * as Styles from "./styles";

interface Props {
  open: boolean;
  onClose: () => void;
  idLead365: string;
  onSuccess?: (data?: any) => void;
  title?: string;
  icon?: React.ReactNode;
  placeholder?: string;
  maxLength?: number;
  confirmLabel?: string;
  confirmingLabel?: string;
  initialValue?: string;
  onSubmit?: (text: string) => Promise<void>;
}

const AtualizarLeadModal: React.FC<Props> = ({
  open,
  onClose,
  idLead365,
  onSuccess,
  title = "Atualizar Lead",
  icon,
  placeholder = "Digite a descrição da tarefa...",
  maxLength = 5000,
  confirmLabel = "Atualizar",
  confirmingLabel = "Atualizando...",
  initialValue = "",
  onSubmit,
}) => {
  const [descricaoTarefa, setDescricaoTarefa] = useState(initialValue);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [dialogShake, setDialogShake] = useState<boolean>(false);

  const mutation = usePostAtualizarLeadTarefaConcluida();

  React.useEffect(() => {
    if (open) {
      setDescricaoTarefa(initialValue);
    }
  }, [open, initialValue]);

  const isPending = onSubmit ? isSubmitting : mutation.isLoading;

  const handleBDClick = () => {
    setDialogShake(true);
    const delayDebounceFn = setTimeout(() => {
      setDialogShake(false);
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  };

  const handleAtualizar = async () => {
    if (!descricaoTarefa.trim()) {
      return;
    }

    if (onSubmit) {
      setIsSubmitting(true);
      try {
        await onSubmit(descricaoTarefa);
        setDescricaoTarefa("");
        onClose();
        if (onSuccess) {
          onSuccess();
        }
      } catch {
        // error handling is done in the onSubmit callback
      } finally {
        setIsSubmitting(false);
      }
      return;
    }

    mutation.mutate(
      {
        idLead365,
        DescricaoTarefa: descricaoTarefa,
      },
      {
        onSuccess: (responseData: any) => {
          setDescricaoTarefa("");
          onClose();
          if (onSuccess) {
            onSuccess(responseData?.data);
          }
        },
      }
    );
  };

  const handleCancel = () => {
    setDescricaoTarefa("");
    onClose();
  };

  return (
    <Styles.Modal
      PaperProps={{
        style: {
          borderRadius: 4,
          width: 520,
        },
      }}
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleCancel();
        } else {
          handleBDClick();
        }
      }}
      className={`shake-${dialogShake}`}
    >
      <Styles.DialogHeader>
        <Styles.Header>
          <Styles.TitleHeader>
            {icon || <ClockModalIcon />}
            {title}
          </Styles.TitleHeader>
          <Styles.IconButton onClick={handleCancel}>
            <GrFormClose />
          </Styles.IconButton>
        </Styles.Header>
      </Styles.DialogHeader>

      <Styles.ContainerModal>
        <Styles.TextArea
          placeholder={placeholder}
          value={descricaoTarefa}
          onChange={(e) => setDescricaoTarefa(e.target.value)}
          maxLength={maxLength}
        />
        <Styles.CharCount>
          {descricaoTarefa.length}/{maxLength}
        </Styles.CharCount>

        <Styles.ButtonsContainer>
          <Styles.CancelButton onClick={handleCancel}>
            Cancelar
          </Styles.CancelButton>
          <Styles.ConfirmButton
            onClick={handleAtualizar}
            disabled={!descricaoTarefa.trim() || isPending}
          >
            {isPending ? confirmingLabel : confirmLabel}
          </Styles.ConfirmButton>
        </Styles.ButtonsContainer>
      </Styles.ContainerModal>
    </Styles.Modal>
  );
};

export default AtualizarLeadModal;
